import React from "react";
import "./hero-headline.scss";

interface Props {
  alt?: string;
}

const HeroHeadline: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  alt,
}) => (
  <div className="hero-headline highlight highlight--peach">
    {children}{" "}
    <span className="hero-headline__alt highlight--orange">{alt}</span>
  </div>
);

export default HeroHeadline;
